import React from "react";
import { useNavigate } from "react-router-dom";
const InvoiceTable = ({ TableData, TableHeading }) => {
  const Navigation = useNavigate();
  return (
    <table className="w-full rounded shadow-custom bg-[#408E91]">
      <thead className="w-full      ">
        <tr className="grid grid-cols-6 py-3 rounded-t-xl place-content-center place-items-center ">
          {TableHeading.map((val, i) => {
            return (
              <th key={i} className="text-white text-sm font-medium ">
                {val.heading}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody className="w-full h-full  flex flex-col ">
        {TableData.map((val, i) => {
          return (
            <tr
              key={i}
              onClick={() => {
                Navigation("");
              }}
              className={`grid grid-cols-6 font-normal text-sm py-3 cursor-pointer hover:bg-gray-100 place-content-center place-items-center bg-gray-50 border-b border-gray-400`}
            >
              <td className="">{val.sn}</td>
              <td className="">{val.name}</td>
              <td className="">{val.invc}</td>
              <td className="">{val.date}</td>
              <td className="">
                <span>Rs.</span>
                {val.total}
              </td>
              <td>
                <button className="px-3 py-1 text-white font-medium text-xs bg-[#82CD47] rounded-lg">
                  Paid
                </button>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default InvoiceTable;
